<template>
  <form :id="'frm-'+id" class="px-3" method="post" onsubmit="return false">
    <div :aria-labelledby="id+'-title'"
         :data-id="name"
         :id="id"
         :data-backdrop="'static'"
         :data-keyboard="'false'"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header modal-body-scrolled pb-0">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body overflow-x-hidden px-0 md:px-3">
            <div v-if="addingCoResearchers" class="mx-3 mt-3">
              <p class="alert alert-info">
                Para agregar coinvestigadores internos, favor de verificar que sea el correo institucional.
              </p>
            </div>
            <users-list :class="{ 'mb-4': selectedUsers.length }"
                        :selected-users="selectedUsers"
                        :load-users-function="loadUsersFunction"
                        :users="researchers"
                        :is-publication="isPublication"
                        :amendment="amendment"
                        @user-selected="userSelected"
                        @close-modal="close"
                        @invitations-sent="() => close()"
                        avatar-size="md"
                        class="mt-2"
                        ref="users-list">
            </users-list>
          </div>
          <div class="modal-footer flex justify-content-between px-2 shadow-none">
            <button @click="clearSearch" class="btn btn-secondary ml-2" data-dismiss="modal" type="button">Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import UsersList from './UsersList'
  import { mapGetters, mapState } from 'vuex'
  
  export default {
    name: 'UsersModal',
    components: {
      UsersList,
    },
    props: {
      title: {
        default: 'Seleccione un usuario',
      },
      id: {
        default: 'users-modal',
      },
      name: {
        default: 'users-modal',
      },
      selectedUsers: {
        type: Array,
        default: () => ([]),
      },
      loadUsersFunction: {
        type: Function,
      },
      isPublication: {
        type: Boolean,
        default: false,
      },
      addingCoResearchers: {
        type: Boolean,
        default: false,
      },
      amendment: {
        type: Object,
        default: null,
      },
    },
    methods: {
      clearSearch() {
        this.$refs['users-list'].clearSearch()
      },
      load() {
        this.$refs['users-list'].load()
      },
      close() {
        $(this.$el).find('.modal').modal('hide')
      },
      userSelected(user, cb) {
        this.$emit('user-selected', user, cb)
      },
    },
    computed: {
      ...mapState(['user']),
      
      ...mapGetters({
        researchers: 'users/researchers',
        protocol: 'protocols/selectedProtocol',
      }),
    },
  }
</script>
